type ErrorWithMessage = {
	message: string
}

function isErrorWithMessage(error: unknown): error is ErrorWithMessage {
	return (
		typeof error === 'object' &&
		error !== null &&
		'message' in error &&
		typeof (error as Record<string, unknown>).message === 'string'
	)
}
function isGraphqlErrorWithMessage(
	unknownError: unknown
): unknownError is { errors: [ErrorWithMessage] } {
	// @ts-expect-error
	if (!unknownError?.errors) {
		return false
	}
	const errors = (unknownError as { errors: Array<unknown> }).errors
	if (
		Array.isArray(errors) &&
		errors.length > 0 &&
		isErrorWithMessage(errors[0])
	)
		return true
	return false
}

function toErrorWithMessage(maybeError: unknown): ErrorWithMessage {
	if (isErrorWithMessage(maybeError)) return maybeError
	if (isGraphqlErrorWithMessage(maybeError)) {
		return {
			message: maybeError.errors[0].message,
		}
	}
	try {
		return new Error(JSON.stringify(maybeError))
	} catch {
		// fallback in case there's an error stringifying the maybeError
		// like with circular references for example.
		return new Error(String(maybeError))
	}
}

function getErrorMessage(error: unknown) {
	return toErrorWithMessage(error).message
}

export { getErrorMessage }
